import cleanedFilename from '~/util/cleanedFilename';

export default {
  LOADING_ICON: `${cleanedFilename(__filename)}-loading-icon`,
};
